export function hasHtmlTags(string: string): boolean {
    return /<[^>]*>/g.test(string);
}

export function isEmptyHtml(html?: string | null): boolean {
    if (!html) return true;
    // Remove all HTML tags and trim whitespace
    const textContent = html.replace(/<[^>]*>/g, '').trim();

    return textContent.length === 0;
}
